import initialState from '../../../../store/initialState';
import * as forecastingForecastTypes from '../services/ForecastingForecastActionType';

const types = {...forecastingForecastTypes};

const forecastingForecastReducer = (state = initialState.forecastingForecastReducer, action) => {
    switch (action.type) {

        // Common cases
        case types.UPDATE_FORECASTING_FORECAST_REDUCER:
            return { ...state, ...action.payload };

        default:
            return state;
    }
};

export default forecastingForecastReducer;